export default (currencyCode) => {
    switch(currencyCode) {
        case 'INR': return '₹';
        case 'USD': return '$';
        case 'NPR': return 'रू';
        case 'AED': return 'د.إ';
        default: return '';
    }
}